// Stream URL Utilities - 2ECOMP Fleet Management

/**
 * Generate stream path for a device/channel
 * @param {string|number} deviceId - Device unique ID or IMEI
 * @param {number} channel - Camera channel (1-8)
 * @returns {string} Stream path
 */
export const getStreamPath = (deviceId, channel = 1) => {
  return `live/${deviceId}-${channel}`;
};

/**
 * Get M7S API endpoint for stream list
 * Nginx proxies /api/ to M7S (jt1078-server:8088)
 * @param {string} baseUrl - Base URL from useCameraServer()
 * @returns {string} API URL
 */
export const getStreamListUrl = (baseUrl) => {
  return `${baseUrl}/api/streams`;
};

/**
 * JT1078 server configuration for device setup
 * @param {Object} cameraServer - Object from useCameraServer()
 * @returns {{ ip: string, port: number, playbackPort: number }}
 */
export const getJt1078Config = (cameraServer) => ({
  ip: cameraServer.ip,
  port: cameraServer.jt1078Port,
  playbackPort: cameraServer.jt1078Port,
});
